import { TActions } from '../../types';
import { ICalltracking } from './types';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../publishTerms';
import { defaultState } from './defaultState';
import { SET_CALLTRACKING_ENABLED } from './actions';

export function calltracking(state: ICalltracking = defaultState, action: TActions): ICalltracking {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      const { calltracking } = action.payload;

      return {
        ...state,
        ...calltracking,
      };
    }

    case SET_CALLTRACKING_ENABLED: {
      const isEnabled = action.payload;

      return {
        ...state,
        isEnabled,
      };
    }

    default:
      return state;
  }
}
